export const UPLOAD_IMAGE_BY_CARRIER_REQUEST = "UPLOAD_IMAGE_BY_CARRIER_REQUEST";
export const UPLOAD_IMAGE_BY_CARRIER_SUCCESS = "UPLOAD_IMAGE_BY_CARRIER_SUCCESS";
export const UPLOAD_IMAGE_BY_CARRIER_FAILURE = "UPLOAD_IMAGE_BY_CARRIER_FAILURE";
export const uploadImageByCarrierSuccess = (payload) => ({
    type: UPLOAD_IMAGE_BY_CARRIER_SUCCESS,
    payload,
});
export const uploadImageByCarrierRequest = (payload) => ({
    type: UPLOAD_IMAGE_BY_CARRIER_REQUEST,
    payload,
});
export const uploadImageByCarrierFailure = (payload) => ({
    type: UPLOAD_IMAGE_BY_CARRIER_FAILURE,
    payload,
});
